<template>
  <el-dialog :title="title" :visible.sync="dialogFormVisible" width="80vw" height="600px" @close="close">
    <div class="table-container">
      <el-table ref="tableSort" v-loading="listLoading" :data="list" border>
        <!-- 订单编号 -->
        <el-table-column align="center" show-overflow-tooltip prop="points" label="积分" min-width="350"></el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="points" label="类型" min-width="350">
          <template #default="{ row }">
              <span v-if="row.sign==1">支出</span>
              <span v-if="row.sign==0">收入</span>
          </template>
        </el-table-column>
        <el-table-column align="center" show-overflow-tooltip prop="add_time" label="消费时间" min-width="350"></el-table-column>
        <!--运单号 -->
      </el-table>

      <el-pagination  :current-page="queryForm.page" :page-size="queryForm.limit" :layout="layout" :total="total"
        @size-change="handleSizeChange" @current-change="handleCurrentChange"></el-pagination>
    </div>
  </el-dialog>
</template>

<script>
  import {
    Member_user_points_list
  } from '@/api/xgcApi'
  import {
    getUploadUrl
  } from '@/config'

  export default {
    name: 'userDetails',
    data() {
      return {
        queryForm:{
          page:1,
          limit:10
        },
        listLoading:true,
        dialogFormVisible:false,
        total:0,
        layout: 'total, sizes, prev, pager, next, jumper',
        title:'积分记录'
      }
    },
    methods: {
      handleSizeChange(val) {
        this.queryForm.limit = val
        this.getList()
      },
      handleCurrentChange(val) {
        this.queryForm.page = val
        this.getList()
      },
      showEdit(row){
        this.row = row
        this.dialogFormVisible = true
        this.listLoading = true
        this.queryForm.page = 1
        this.getList()
      },
      getList(){
        var data = {
          ...this.queryForm,
          uid:this.row.id
        }
        Member_user_points_list(data).then(res=>{
          this.listLoading = false
          this.list =res.data.list
          this.total = res.data.count
        })
      },
      close(){
        this.dialogFormVisible = false
      },
    },
  }
</script>
<style scoped>

</style>
